<div [ngClass]="styleClass" class="status-label" >
  {{ label }}
</div>
